import React from 'react'
import { ScrollView, TouchableOpacity } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@style/service'
import { ProgramCard, LoadingProgramCard } from '@src/screens/Learn/components/ProgramCard'
import { useProgramsWithContent } from '@src/screens/Learn/hooks'
import { AppStackParamList } from '@src/navigation/types'

const CARD_WIDTH = 130
const CARD_HEIGHT = 170

export const LearnHubCarousel = () => {
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const { programs, isLoading } = useProgramsWithContent()

  const handleProgramPress = (programId: string) => {
    navigation.navigate('CoursesProgram', { programId })
  }

  if (isLoading) {
    return (
      <ScrollView
        horizontal
        contentContainerStyle={styles.scrollContent}
        showsHorizontalScrollIndicator={false}
      >
        <LoadingProgramCard style={styles.card} />
        <LoadingProgramCard style={styles.card} />
        <LoadingProgramCard style={styles.card} />
      </ScrollView>
    )
  }

  return (
    <ScrollView
      horizontal
      contentContainerStyle={styles.scrollContent}
      showsHorizontalScrollIndicator={false}
    >
      {programs.map((program) => (
        <TouchableOpacity
          key={program.id}
          accessibilityLabel={program.title}
          onPress={() => handleProgramPress(program.id)}
        >
          <ProgramCard program={program} style={styles.card} verticalTile />
        </TouchableOpacity>
      ))}
    </ScrollView>
  )
}

const themedStyle = StyleService.create({
  scrollContent: {
    gap: 8,
  },
  card: {
    width: CARD_WIDTH,
    height: CARD_HEIGHT,
    borderRadius: 16,
  },
})
